export default __webpack_public_path__ + "static/media/hero.9c9f143f.png";